import '../css/yodah.scss';

/* this is the main file that pulls together all of the JS before it is compiled */
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import 'owl.carousel2.thumbs';
import "lightbox2/dist/css/lightbox.css";

import 'lightbox2';
import axios from "axios";
// import babelPolyfill from 'babel-polyfill'
import Vue from 'vue';
import VueAxios from 'vue-axios';
import Vuex from 'vuex';
import VeeValidate from "vee-validate";
import { Tooltip } from 'floating-vue';
Vue.component('VTooltip', Tooltip);
import 'floating-vue/dist/style.css'

import VuexStore from './vuex';
Vue.use(Vuex);

const store = new Vuex.Store(VuexStore);
Vue.use(VueAxios, axios);

Vue.filter('truncate', function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
});

Vue.filter('money', function (value) {
    let val = (value/1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

let VVconfig = {
    classes: true,
    classNames: {
        valid: 'has-success',
        invalid: 'has-danger'
    },
    fieldsBagName: 'vvFields',
};

import { Validator } from 'vee-validate';
const dictionary = {
    en: {
        attributes: {
            firstName: 'first name',
            lastName: 'last name',
            building_num: 'building name/number',
            city: 'town',
            post_code: 'post code'
        }
    }
};

Validator.localize(dictionary);
Vue.use(VeeValidate, VVconfig);

if(!store.state.yVersion || store.state.yVersion < 4) {
    console.log('reset store...');
    store.replaceState({}); // resets the store to fix issue with updated plugin. todo, it requres reload of page to reload state, would be good if we could fig
    store.commit('updateyVersion', 4);
    window.location.reload();
}

/* import the components */
import ProductSelector from './product-selector.vue';
if(jQuery('#product-selector').length !== 0) {
    ProductSelector.store = store;
    new Vue(ProductSelector);
}

import Products from './products.vue';
if(jQuery('#products').length !== 0) {
    Products.store = store;
    new Vue(Products);
}

import Breadcrumb from './breadcrumb.vue';
if(jQuery('#breadcrumb').length !== 0) {
    Breadcrumb.store = store;
    new Vue(Breadcrumb);
}

import CategoryTree from './category-root.vue';
if(jQuery('.y-category-tree').length > 0) {
    CategoryTree.store = store;
}
let i = 1;
jQuery('.y-category-tree').each(function() {
    jQuery(this).addClass('y-category-tree-instance-'+i);
    CategoryTree.el = '.y-category-tree-instance-'+i;
    new Vue(CategoryTree);
    i++;
});

import BasketInfo from './basket-info.vue';
if(jQuery('#basket-info').length !== 0) {
    BasketInfo.store = store;
    new Vue(BasketInfo);
}

import BasketTable from './basket-table.vue';
if(jQuery('#basket-table').length !== 0) {
    BasketTable.store = store;
    new Vue(BasketTable);
}

import BasketSummary from './basket-summary.vue';
if(jQuery('#basket-summary').length !== 0) {
    BasketSummary.store = store;
    new Vue(BasketSummary);
}

import Checkout from './checkout.vue';
if(jQuery('#checkout').length !== 0) {
    Checkout.store = store;
    Vue.use(VeeValidate, {
        classes: true,
        classNames: {
            valid: 'has-success',
            invalid: 'has-danger'
        }
    });
    new Vue(Checkout);
}

jQuery(document).ready(function(){
    console.log('Yodah E-com version: ', my_ajax_object.version);
    jQuery(".yodah-product-carousel").owlCarousel({
        autoHeight: true,
        autoplay: true,
        autoplayHoverPause: true,
        dots: false,
        items: 1,
        margin: 10,
        lazyLoad: false,
        loop: true,
        thumbs: true,
        thumbsPrerendered: true,
        video: true,  
    });

    jQuery('.yodah_search_input').on('keyup', function () {
        let str = $(this).val();
        let searchId = 'yodah_search_' + $(this).data("search-id");
        // console.log(searchId);
        jQuery.ajax({
            type: 'POST',
            url: my_ajax_object.ajax_url,
            data: {
                "action": "yodah_search_action",
                "str": str
            },
            success: function (response) {
                if (response.data.data) {
                    $('#' + searchId).show().html(response.data.data);
                } else {
                    $('#' + searchId).hide();
                }
            }
        });
    });

    jQuery(window).click(function () {
        jQuery('#yodah_search').hide();
    });
});
